import { FormField, Select } from '@amzn/awsui-components-react';
import { FORM_ERROR_SELECTOR } from '../../../../../imt/components/Instructor/FormSections/FormSections.common';

interface SelectActivityTypeProps {
    onChange: (activityType: string) => void;
    options: Array<{ label: string; id: string }>;
    selectedOption: { label: string; id: string } | null;
    isLoading?: boolean;
    error?: string;
    onRecoveryClick?: () => void;
    statusType?: 'loading' | 'error' | 'finished';
    'data-testid'?: string;
}

const SelectActivityType = ({
    onChange,
    options,
    selectedOption,
    isLoading,
    error,
    onRecoveryClick,
    statusType,
    'data-testid': testId = 'activity-type',
}: SelectActivityTypeProps) => {
    return (
        <FormField errorText={error} label="Activity type">
            <Select
                className={error && FORM_ERROR_SELECTOR}
                placeholder={
                    isLoading
                        ? 'Loading activity types'
                        : 'Select an activity type'
                }
                options={options}
                selectedOption={selectedOption}
                onChange={(e) => onChange(e.detail.selectedOption.label)}
                onRecoveryClick={onRecoveryClick}
                loadingText="Loading activity types"
                errorText="An error occurred while loading activity types"
                recoveryText="Retry"
                empty="No activity types found"
                statusType={statusType}
                data-testid={testId}
            />
        </FormField>
    );
};

export default SelectActivityType;
